const color = {
  primary: '#fff',
  secondry: '#e53935',
};

export default color;
